// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Tdkt","header":"Messages_header__26vfd"};